"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamContribution = exports.GameMessageType = void 0;
const streaming_1 = require("../streaming");
const agent_1 = require("../agent");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const Log_1 = __importDefault(require("../Log"));
const uuid_1 = require("uuid");
// Must be kept in sync with PixelStreamingProtocol::EToPlayerMsg C++ enum.
const ToClientMessageType = {
    QualityControlOwnership: 0,
    Response: 1,
    Command: 2,
    FreezeFrame: 3,
    UnfreezeFrame: 4,
    VideoEncoderAvgQP: 5,
    LatencyTest: 6,
    InitialSettings: 7
};
exports.GameMessageType = {
    Response: 'Response',
    FreezeFrame: 'FreezeFrame',
    UnfreezeFrame: 'UnfreezeFrame'
};
class StreamContribution {
    constructor(id, agent, owner, version, description) {
        // Android/Chrome workaround where H264 may not appear during initial offer
        this.verifyH264 = (count = 10) => __awaiter(this, void 0, void 0, function* () {
            if (count > 0) {
                const pc1 = new RTCPeerConnection({});
                try {
                    pc1.addTransceiver('video');
                    const offer = yield pc1.createOffer();
                    if (offer.sdp.search(/rtpmap:([0-9]+) H264/g) != -1) {
                        Log_1.default.info('H264 is supported.');
                        return true;
                    }
                    else {
                        yield new Promise((r) => setTimeout(r, 250));
                        return yield this.verifyH264(count - 1);
                    }
                }
                catch (e) {
                    Log_1.default.error(e);
                    return false;
                }
            }
            else {
                Log_1.default.error('Timed out waiting for H.264 support');
                return false;
            }
        });
        this.consume = (options) => __awaiter(this, void 0, void 0, function* () {
            const pendingIceCandidates = [];
            if (!(yield this.verifyH264())) {
                throw 'Could not find valid h264 codec in RTCPeerConnection';
            }
            if (!options) {
                options = streaming_1.DefaultStreamerOptions;
            }
            const result = {
                peerConnection: null,
                videoStream: null,
                audioStream: null,
                inputEmitter: null,
                messageReceiver: new rxjs_1.Subject()
            };
            const elements = new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                try {
                    const config = {
                        sdpSemantics: 'unified-plan',
                        iceServers: options.iceServers,
                        iceTransportPolicy: (options.forceRelay ? 'relay' : 'all'),
                        iceCandidatePoolSize: 4
                    };
                    Log_1.default.info('Creating peer connection', config);
                    result.peerConnection = this.peerConnection = new RTCPeerConnection(config);
                    // Chrome does not report Failed through ICEConnectionState due to trickle-ice
                    // So we monitor the connection state here.
                    result.peerConnection.onconnectionstatechange = () => {
                        if (result.peerConnection.connectionState === 'failed') {
                            this.statusBehavior.next(streaming_1.StreamerStatus.Failed);
                        }
                    };
                    result.peerConnection.oniceconnectionstatechange = () => {
                        if (result.peerConnection.iceConnectionState === 'checking') {
                            this.statusBehavior.next(streaming_1.StreamerStatus.Checking);
                        }
                        else if (result.peerConnection.iceConnectionState === 'disconnected') {
                            this.statusBehavior.next(streaming_1.StreamerStatus.Disconnected);
                        }
                        else if (result.peerConnection.iceConnectionState === 'failed') {
                            this.statusBehavior.next(streaming_1.StreamerStatus.Failed);
                        }
                        else if (result.peerConnection.iceConnectionState === 'closed') {
                            this.statusBehavior.next(streaming_1.StreamerStatus.Closed);
                        }
                        else if (result.peerConnection.iceConnectionState === 'completed') {
                            this.statusBehavior.next(streaming_1.StreamerStatus.Completed);
                        }
                        else if (result.peerConnection.iceConnectionState === 'connected') {
                            this.statusBehavior.next(streaming_1.StreamerStatus.Connected);
                        }
                    };
                    // Subscribe to signaling messages
                    this.localAgent.subscribeToMessages(agent_1.MessageTypes.PRIVATE, {
                        privateMessage: (data) => {
                            const { type, payload, senderId } = data;
                            if (type === 'WEBRTC_UNREAL_STREAM' && senderId === this.owner.id) {
                                const message = JSON.parse(payload)['message'];
                                Log_1.default.info(`CirrusMessage: ` + payload);
                                if (message.type === 'answer') {
                                    const answer = message;
                                    Log_1.default.info('Received answer from streamer', answer);
                                    result.peerConnection
                                        .setRemoteDescription(answer)
                                        .then(() => {
                                        this.answered = true;
                                        pendingIceCandidates.forEach((c) => result.peerConnection.addIceCandidate(c));
                                    })
                                        .catch((err) => {
                                        Log_1.default.error(err);
                                        this.statusBehavior.next(streaming_1.StreamerStatus.Failed);
                                    });
                                }
                                else if (message.type === 'iceCandidate') {
                                    const candidate = new RTCIceCandidate(message['candidate']);
                                    if (!candidate) {
                                        return;
                                    }
                                    Log_1.default.info('Received iceCandidate from streamer', candidate);
                                    if (this.answered) {
                                        result.peerConnection.addIceCandidate(candidate);
                                    }
                                    else {
                                        pendingIceCandidates.push(candidate);
                                    }
                                }
                                else if (message.type === 'disconnectPlayer') {
                                    Log_1.default.info('Received disconnectPlayer from steamer');
                                    result.peerConnection.close();
                                    this.ended = true;
                                }
                                else if (message['type'] === 'playerCount') {
                                    Log_1.default.info('Player count', JSON.stringify(message));
                                }
                                else {
                                    Log_1.default.debug('Unsupported message', JSON.stringify(message));
                                }
                            }
                        }
                    });
                    // Handle ICE Candidates
                    result.peerConnection.onicecandidate = (ev) => {
                        if (!ev.candidate) {
                            return;
                        }
                        const cirrusCandidate = { type: 'iceCandidate', candidate: ev.candidate };
                        this.localAgent.sendMessage('WEBRTC_UNREAL_STREAM', JSON.stringify({
                            webrtc_type: 'iceCandidate',
                            payload: cirrusCandidate
                        }), this.owner);
                    };
                    // Build and dispatch offer
                    result.peerConnection.addTransceiver('audio', { direction: 'recvonly' });
                    result.peerConnection.addTransceiver('video', { direction: 'recvonly' });
                    const dc = result.peerConnection.createDataChannel(`${uuid_1.v4()}`);
                    dc.binaryType = 'arraybuffer';
                    dc.onopen = () => {
                        result.inputEmitter = new streaming_1.InputEmitter(dc);
                        if (result.audioStream !== null && result.videoStream !== null && result.inputEmitter !== null) {
                            const latencyProbe = () => {
                                this.latencyTestTimings.Reset();
                                this.latencyTestTimings.TestStartTimeMs = Date.now();
                                const descriptor = {
                                    StartTime: this.latencyTestTimings.TestStartTimeMs
                                };
                                result.inputEmitter.EmitDescriptor(ToClientMessageType.LatencyTest, descriptor);
                            };
                            latencyProbe();
                            //setInterval(latencyProbe, 1000);
                            result.inputEmitter.SendInputData(new Uint8Array([ToClientMessageType.InitialSettings]).buffer);
                            result.inputEmitter.SendInputData(new Uint8Array([ToClientMessageType.QualityControlOwnership]).buffer);
                            resolve(result);
                        }
                    };
                    dc.onclose = () => {
                        result.messageReceiver.complete();
                    };
                    dc.onmessage = (ev) => {
                        const view = new Uint8Array(ev.data);
                        if (view[0] === ToClientMessageType.Response) {
                            const response = new TextDecoder('utf-16').decode(view.slice(1));
                            result.messageReceiver.next(response);
                        }
                        else if (view[0] === ToClientMessageType.QualityControlOwnership) {
                            // const ownership = view[1] === 0 ? false : true;
                            //console.log('Received quality controller message, will control quality: ' + ownership);
                            // If we own the quality control, we can't relenquish it. We only loose
                            // quality control when another peer asks for it
                        }
                        else if (view[0] === ToClientMessageType.Command) {
                            const commandAsString = new TextDecoder('utf-16').decode(view.slice(1));
                            //console.log(commandAsString);
                            const command = JSON.parse(commandAsString);
                            if (command.command === 'onScreenKeyboard') {
                                //showOnScreenKeyboard(command);
                            }
                        }
                        else if (view[0] === ToClientMessageType.FreezeFrame) {
                            const response = '{"protocol":"pureweb.actions", "message_type":"freeze_notification", "frozen":true}';
                            result.messageReceiver.next(response);
                        }
                        else if (view[0] === ToClientMessageType.UnfreezeFrame) {
                            const response = '{"protocol":"pureweb.actions", "message_type":"freeze_notification", "frozen":false}';
                            result.messageReceiver.next(response);
                        }
                        else if (view[0] === ToClientMessageType.VideoEncoderAvgQP) {
                            // const VideoEncoderQP = new TextDecoder('utf-16').decode(view.slice(1));
                            //console.log(`received VideoEncoderAvgQP ${VideoEncoderQP}`);
                        }
                        else if (view[0] == ToClientMessageType.LatencyTest) {
                            const latencyTimingsAsString = new TextDecoder('utf-16').decode(view.slice(1));
                            const latencyTimingsFromUE = JSON.parse(latencyTimingsAsString);
                            this.latencyTestTimings.SetUETimings(latencyTimingsFromUE);
                            //console.log(this.latencyTestTimings);
                        }
                        else if (view[0] == ToClientMessageType.InitialSettings) {
                            // const settingsString = new TextDecoder('utf-16').decode(view.slice(1));
                            //const settingsJSON = JSON.parse(settingsString);
                            // console.log(settingsJSON);
                        }
                        else {
                            console.error(`unrecognized data received, packet ID ${view[0]}`);
                        }
                    };
                    dc.onerror = (event) => {
                        const errorMessage = `Error: ${event.error.message} occured while handling streamer data channel messages`;
                        Log_1.default.error(errorMessage);
                        result.messageReceiver.error(errorMessage);
                    };
                    result.peerConnection.ontrack = (event) => {
                        if (event.track.kind == 'video') {
                            Log_1.default.info('Received video track');
                            result.videoStream = event.streams[0];
                        }
                        else if (event.track.kind == 'audio') {
                            Log_1.default.info('Received audio track');
                            result.audioStream = event.streams[0];
                        }
                        if (result.audioStream !== null && result.videoStream !== null && result.inputEmitter !== null) {
                            resolve(result);
                        }
                    };
                    const sessionDescription = yield result.peerConnection.createOffer();
                    // Adjust bandwidth
                    const bandwidth = `x-google-min-bitrate=${options.bandwidth.minBitrateKbps};x-google-start-bitrate=${options.bandwidth.startingBitrateKbps};x-google-max-bitrate=${options.bandwidth.maxBitrateKbps}`;
                    sessionDescription.sdp = (_a = sessionDescription.sdp) === null || _a === void 0 ? void 0 : _a.replace(/(a=fmtp:\d+ .*level-asymmetry-allowed=.*)\r\n/gm, '$1;' + bandwidth + '\r\n');
                    // Improve audio quality
                    sessionDescription.sdp = sessionDescription.sdp.replace('useinbandfec=1', 'useinbandfec=1;stereo=' + options.audio.stereo + ';maxaveragebitrate=' + options.audio.maxAverageBitrateKbps);
                    // Chrome 89 work around
                    sessionDescription.sdp = sessionDescription.sdp.replace('a=extmap-allow-mixed\r\n', '');
                    yield result.peerConnection.setLocalDescription(sessionDescription);
                    this.localAgent.sendMessage('WEBRTC_UNREAL_STREAM', JSON.stringify({
                        webrtc_type: 'offer',
                        payload: sessionDescription
                    }), this.owner);
                    Log_1.default.info('StreamContribution offer sent.');
                }
                catch (err) {
                    reject(err);
                }
            }));
            return elements;
        });
        this.close = () => {
            this.peerConnection.close();
            this.statusBehavior.complete();
            this.ended = true;
        };
        this.id = id;
        this.localAgent = agent;
        this.owner = owner;
        this.version = version;
        this.description = description;
        this.answered = false;
        this.ended = false;
        this.statusBehavior = new rxjs_1.BehaviorSubject(streaming_1.StreamerStatus.New);
        // Latency tester
        this.latencyTestTimings = {
            TestStartTimeMs: null,
            UEReceiptTimeMs: null,
            UEPreCaptureTimeMs: null,
            UEPostCaptureTimeMs: null,
            UEPreEncodeTimeMs: null,
            UEPostEncodeTimeMs: null,
            UETransmissionTimeMs: null,
            BrowserReceiptTimeMs: null,
            FrameDisplayDeltaTimeMs: null,
            history: [],
            Reset: function () {
                this.TestStartTimeMs = null;
                this.UEReceiptTimeMs = null;
                this.UEPreCaptureTimeMs = null;
                this.UEPostCaptureTimeMs = null;
                this.UEPreEncodeTimeMs = null;
                this.UEPostEncodeTimeMs = null;
                this.UETransmissionTimeMs = null;
                this.BrowserReceiptTimeMs = null;
                this.FrameDisplayDeltaTimeMs = null;
            },
            SetUETimings: function (UETimings) {
                this.history.push(UETimings);
                if (this.history.length > 60) {
                    this.history.shift();
                }
                this.UEReceiptTimeMs = UETimings.ReceiptTimeMs;
                this.UEPreCaptureTimeMs = UETimings.PreCaptureTimeMs;
                this.UEPostCaptureTimeMs = UETimings.PostCaptureTimeMs;
                this.UEPreEncodeTimeMs = UETimings.PreEncodeTimeMs;
                this.UEPostEncodeTimeMs = UETimings.PostEncodeTimeMs;
                this.UETransmissionTimeMs = UETimings.TransmissionTimeMs;
                this.BrowserReceiptTimeMs = Date.now();
                // this.OnAllLatencyTimingsReady(this);
            },
            SetFrameDisplayDeltaTime: function (DeltaTimeMs) {
                if (this.FrameDisplayDeltaTimeMs == null) {
                    this.FrameDisplayDeltaTimeMs = Math.round(DeltaTimeMs);
                    // this.OnAllLatencyTimingsReady(this);
                }
            }
            // OnAllLatencyTimingsReady: (_Timings): void => {
            // this.history.push(_Timings);
            //}
        };
    }
    get status() {
        return this.statusBehavior.pipe(operators_1.startWith(this.statusBehavior.getValue()), operators_1.distinctUntilChanged());
    }
}
exports.StreamContribution = StreamContribution;
//# sourceMappingURL=StreamContribution.js.map